import React from 'react';

interface ResultsHeaderProps {
    className?: string;
    field: string;
    label: string;
    sort: {
        field: string;
        dir: string;
    };
    updateSort?: null | ((field: string) => void);
}
function ResultsHeader({
    className = '',
    field,
    label,
    sort,
    updateSort = null,
}: ResultsHeaderProps) {
    function handleClick() {
        if (updateSort) updateSort(field);
    }

    return (
        <th className={`patient-results-header ${className || ''}`} onClick={handleClick}>
            {label}
            {sort.field === field &&
                (sort.dir === 'ASC' ? (
                    <i className="fa-solid fa-chevron-up" />
                ) : (
                    <i className="fa-solid fa-chevron-down" />
                ))}
        </th>
    );
}

export { ResultsHeader };
